import Game from "./Game";
import { SCENES } from "../constants/scenes";
import { MAPS } from "../constants/maps";

export default class ThirdLevel extends Game {
  constructor() {
    super(SCENES.THIRD_LEVEL, MAPS.thirdLevel.key);
  }
}
